/*eslint-disable*/
export const messages = {
  // System notices (truncation / safety refusal)
  "This answer was shortened because it reached the length limit and may be incomplete.": "由于达到长度上限，此回答已被截断，内容可能不完整。",
  "This request can't be answered due to safety guidelines. Please rephrase or ask about a different topic.": "根据安全准则，无法回答此请求。请重新表述或询问其他主题。",
  "Cancel": "取消",
  "Change theme": "更改主题",
  "Clear chat": "清除聊天",
  "Clear chat history": "清除聊天历史",
  "Connecting...": "正在连接...",
  "Continue": "继续",
  "Decrease font size": "减小字体大小",
  "Disclaimer": "免责声明",
  "Enter your message...": "输入您的消息...",
  "Type your message...": "输入您的消息...",
  "Error": "错误",
  "Font size": "字体大小",
  "Increase font size": "增加字体大小",
  "Language": "语言",
  "MJ Lab": "MJ 实验室",
  "Reset font size": "重置字体大小",
  "Respond time: {time}s": "响应时间：{time}秒",
  "Response time:": "响应时间：",
  "Send": "发送",
  "Settings": "设置",
  "Support the project": "支持项目",
  "System": "系统",
  "Theme": "主题",
  "Thinking...": "思考中...",
  "Toggle theme": "切换主题",
  "Welcome to {{name}} by MJ": "欢迎使用 MJ 的 {{name}}",
  "You asked:": "您询问：",
  
  // Headers
  "Ministry of Commerce Laws Expert": "商务部(MoC)法律专家",
  "by MJ": "由 MJ 提供",
  "Hello, I am {{name}}, an AI assistant made by MJ.": "您好，我是 {{name}}，由 MJ 开发的 AI 助手。",
  "I am expert in Ministry of Commerce laws and regulations for Saudi Arabia.": "我是沙特阿拉伯商务部法律和法规方面的专家。",
  "Ask me a question, and I will gladly answer you.": "请向我提问，我将很乐意为您解答。",
  "Do not share confidential data.": "请勿分享机密数据。",
  "I am powered using": "我由以下技术提供支持",
  
  // Disclaimer
  "Disclaimer: {{name}} is an experimental AI assistant designed to respond using data from Saudi Ministry of Commerce laws and regulations, avoiding assumptions or inaccuracies. I am not responsible for its behavior or the correctness of its responses.": "**免责声明：** {{name}} 是一个实验性 AI 助手，旨在使用沙特商务部法律和法规的数据进行回应，避免假设或不准确性。我对其行为或回应的正确性不负责任。",
  
  // Frameworks
  "Automatic detection": "自动检测",
  
  // A. Business Formation and Identity
  "MOC_COMPANIES_LAW": "A1. 商务部公司法",
  "MOC_PROFESSIONAL_COMPANIES_LAW": "A2. 商务部专业公司法",
  "MOC_COMMERCIAL_REGISTER_LAW": "A3. 商务部商业登记法",
  "MOC_MINISTRY_OF_COMMERCE_LAW": "A4. 商务部法",
  "MOC_TRADE_NAMES_LAW": "A5. 商务部商品名称法",
  "MOC_GCC_TRADEMARK_LAW": "A6. 海湾合作委员会商标法",
  
  // B. Financial Instruments, Security, and Insolvency
  "MOC_COMMERCIAL_PAPERS_LAW": "B1. 商务部商业票据法",
  "MOC_COMMERCIAL_PLEDGE_LAW": "B2. 商务部商业质押法",
  "MOC_MOVABLE_PROPERTY_SECURITY_LAW": "B3. 商务部动产担保法",
  "MOC_INSOLVENCY_LAW": "B4. 商务部破产法",
  
  // C. Commercial Relationships and Trade
  "MOC_COMMERCIAL_AGENCIES_LAW": "C1. 商务部商业代理法",
  "MOC_FRANCHISE_LAW": "C2. 商务部特许经营法",
  "MOC_ECOMMERCE_LAW": "C3. 商务部电子商务法",
  "MOC_CHAMBERS_OF_COMMERCE_LAW": "C4. 商务部商会法",
  
  // D. Commercial Records and Information
  "MOC_COMMERCIAL_BOOKS_LAW": "D1. 商务部商业账簿法",
  "MOC_COMMERCIAL_DATA_LAW": "D2. 商务部商业数据法",
  "MOC_PUBLIC_WAREHOUSING_LAW": "D3. 商务部公共仓储法",
  
  // E. Standards, Quality, and Regulated Products
  "MOC_STANDARDS_METROLOGY_LAW": "E1. 商务部标准与计量法",
  "MOC_CALIBRATION_MEASUREMENT_LAW": "E2. 商务部校准与测量法",
  "MOC_PRIVATE_LABORATORIES_LAW": "E3. 商务部私人实验室法",
  "MOC_PRECIOUS_METALS_GEMSTONES_LAW": "E4. 商务部贵金属宝石法",
  "MOC_CHEMICALS_IMPORT_MANAGEMENT_LAW": "E5. 商务部化学品进口管理法",
  
  // F. Professional Regulation and Oversight
  "MOC_ACCOUNTING_AUDITING_LAW": "F1. 商务部会计审计法",
  "MOC_VALUERS_LAW": "F2. 商务部评估师法",
  "MOC_ENGINEERS_LAW": "F3. 商务部工程师法",
  
  // G. Compliance and Dispute Resolution
  "MOC_ANTI_CONCEALMENT_LAW": "G1. 商务部反隐瞒法",
  "MOC_ANTI_MONEY_LAUNDERING_LAW": "G2. 商务部反洗钱法",
  "MOC_ARBITRATION_LAW": "G3. 商务部仲裁法",
  "MOC_COMBATING_COMMERCIAL_ADULTERATION_LAW": "G4. 商务部打击商业掺假法",
  "MOC_GCC_COMBATING_DUMPING_LAW": "G5. 海湾合作委员会反倾销法",
  
  // Models
  "Claude by Anthropic": "Anthropic 的 Claude",
  "DeepSeek by Groq": "Groq 的 DeepSeek",
  "MJ Lab Mode": "MJ 实验室模式",
  
  // Character count
  "{{remainingChars}} character left": "还剩 {{remainingChars}} 个字符",
  "{{remainingChars}} characters left": "还剩 {{remainingChars}} 个字符",
  
  // Error messages
  "An error occurred": "发生错误",
  "Failed to change language": "更改语言失败",
  "Please try again": "请重试",
  "Connection lost": "连接丢失",
  "Reconnecting...": "重新连接中...",
  "Nothing to clear": "没有内容可清除",
  "All messages cleared": "所有消息已清除",
  "All data cleared": "所有数据已清除",
  "Storage limit reached": "存储限制已达到",
  "Some older messages were removed to save space.": "为节省空间，部分较早的消息已被删除。",
  
  // Additional keys
  "Font Size": "字体大小",
  "Language changed to {locale}": "语言已更改为 {locale}",
  "Select language": "选择语言",
  "Support": "支持",
  
  // Brand names (do not translate)
  "Mila": "Mila",
  
  // Message actions
  "Message copied to clipboard": "消息已复制到剪贴板",
  "Read": "阅读",
  "Summarize": "总结",
  
  // Ice Breakers Dialog
  "Message Suggestions": "消息建议",
  "Select a question to quickly start a conversation about Saudi Ministry of Commerce laws.": "选择一个问题，快速开始关于沙特商务部法律的对话。",
  "What are the main requirements under the Companies Law for establishing a limited liability company in Saudi Arabia?": "根据公司法，在沙特阿拉伯成立有限责任公司的主要要求是什么？",
  "How does the Commercial Agencies Law regulate relationships between foreign companies and Saudi agents?": "商业代理法如何规范外国公司与沙特代理商之间的关系？",
  "What protections does the Saudi E-commerce Law provide for online consumers and businesses?": "沙特电子商务法为在线消费者和企业提供了哪些保护？",
  
  // Audio Player Dialog
  "AI Summary": "AI 摘要",
  "Listen to the summarized response using our AI Service.": "使用我们的 AI 服务聆听摘要回复。",
  "Generating summary...": "正在生成摘要...",
  "Preparing audio...": "正在准备音频...",
  
  // Audio Player Error Messages
  "Failed to process text. Please try again.": "文本处理失败。请重试。",
  "Failed to auto-play audio. Click play to try again.": "自动播放音频失败。点击播放重试。",
  "Failed to load audio. Please try again.": "加载音频失败。请重试。",
  "Audio playback was aborted.": "音频播放已中止。",
  "Network error occurred while loading audio.": "加载音频时发生网络错误。",
  "Audio decoding failed.": "音频解码失败。",
  "Audio format not supported.": "不支持的音频格式。",
  "Failed to setup audio playback": "设置音频播放失败",
  "Failed to generate speech": "生成语音失败",
  "Failed to generate audio. Please try again.": "生成音频失败。请重试。",
  "Failed to play audio. Please try again.": "播放音频失败。请重试。"
};